import React from "react";
import LebenForm from '../form-leben'
import RentenForm from '../form-renten'
import RislebForm from "../form-risleb";
import VidForm from '../form-vid'
import VidtForm from '../form-vidt'
import KspForm from '../form-ksp'
import RisForm from '../form-ris'

class Form extends React.Component {
    constructor(props) {
        super(props)
    }


    render () {
        const formTypes = {
            LEB: LebenForm,
            REN: RentenForm,
            RISLEB: RislebForm,
            VID: VidForm,
            VIDT: VidtForm,
            KSP: KspForm,
            RIS: RisForm,
            FOR: RentenForm,
        }

        
        const ComponentName = formTypes[this.props.formType]

        return (
            <ComponentName {...this.props} />
        )
    }
}

export default Form